import { Query } from 'react-query';

export const queryKeyContains = (search: string) => (query: Query) => query.queryKey.includes(search);
